import scrolly from '@js/mixins/scrolly.js';
import scrollytime from '@js/mixins/scrollytime.js';
import scrollies from '@static/scrollies.js';
import { Converter } from 'showdown/dist/showdown.min.js';
import { nextTick } from 'vue';
import { mapGetters, mapState, mapActions } from 'vuex';
import API from '@js/API.js';
import utils from '@js/utils.js';
import cloneDeep from 'lodash.clonedeep';
import { select, selectAll  } from 'd3-selection';

export default {

	inject: ['emitter'],
	mixins: [ 
		scrolly,
		scrollytime
	],
	data() {
		return {
			numLittleSpots: 5,
			scrolly: {},
			currArtifact: null,
			artifactModalVisible: false,
			utils: utils,
			titleHover: false,
			showScrollyArtifacts: true,
			showPlayer: false,
			modalArtifactMode: 'landscape',
			currentBibliographyStage: null,
			animateSection: '',
			showResizeModal: false,
			showScrolly: false,
			inhibitOnSteps: true,
			utils: utils,
			currentInDepth: null,
			currentVideo: {visible: false},
			artifacts: {},
			media: {},
			imagesCallback: null,
			currMobileRemarkablePt: null,
			// converter: null,
		} 
	},
	computed: {
		...mapGetters(['isMobile']),
		...mapState(['scrollys']),
		sections() {
			return this.scrolly.sections !== undefined ? this.scrolly.sections : []
		},
		scrollyName() {
			return this.sections.length && this.$i18n ? this.scrolly.name[this.$i18n.locale] : ''
		},
		historicalMoment() {
			// return this.sections.length ? ((this.currSection.stage && this.currSection.stage.historicalMoment) && this.$i18n.locale ? this.currSection.stage.historicalMoment[this.$i18n.locale] : '') : ''
			let rtn = ''
			return rtn
			// console.log(cloneDeep(this.currSection))
			// console.log('artifacts', cloneDeep(this.artifacts))
			if(!utils.isEmpty(this.artifacts)) {
				// console.log(this.currSection.id)
				let currArtifactKey = Object.keys(this.artifacts).find(el => el == this.currSection.id)
				if(currArtifactKey) {
					if(this.artifacts[currArtifactKey].attributes) {
						let year = this.artifacts[currArtifactKey].attributes.anno
						let test = utils.centuryToRomanNumber(year < 1000 ? Math.ceil(year/100)+1 : Math.ceil(year/100))
						// console.log('century', year, test)
						return rtn = test
					}
				}
				// Object.keys(this.artifacts).forEach(k => {
				// 	let attrs = this.artifacts[k].attributes
				// 	// console.log(cloneDeep(attrs))

				// })
			}

			// if(this.scrolly && this.artifacts) {
			// 	let k = Object.keys(this.artifacts).filter(el => el).find(el => el == this.currSection.id)
			// 	if(k) {
			// 		// console.log(cloneDeep(this.artifacts[k]))
			// 		if(this.artifacts[k].attributes.anno_testo) {
			// 			rtn = this.artifacts[k].attributes.anno_testo
			// 		}
			// 	}
			// }

			// return rtn
		},
		numStages() {
			if(!this.sections.length) return 0

			let rtn = this.sections.map(el => el.stage.id)
			rtn = rtn.filter((item, pos) => rtn.indexOf(item) == pos)
			return rtn.length
		},
		stages() {
			if(!this.sections.length) return []

			let temp = this.sections.filter(el => el.stage).map(el => el.stage)
			let rtn = []
			temp.forEach(el => {
				if(!rtn.length || !rtn.find(t => t.id == el.id)) {
					rtn.push(el)
				}
			})
			return rtn
		},
		currStage() {
			return this.sections.length ? this.currSection.stage.id : 0
		},
		currStageName() {
			return this.sections.length ? 
				(this.currSection.stage && 
					this.$i18n.locale && this.currSection.id !== 's1' ? this.currSection.stage.name[this.$i18n.locale] : ''
				) 
			: ''
		},
		currStageNumSections() {
			return this.sections.length ? this.sections.filter(s => s.stage).filter(s => this.currSection.stage ? s.stage.id == this.currSection.stage.id : 0).length : 0
		},
		currStageSectionIndex() {
			return this.sections.length ? ( this.currSection.stage ? this.sections.filter(s => s.stage).filter(s => s.stage.id == this.currSection.stage.id).findIndex(s => s.id == this.currSection.id) : 0) : 0
		},
		scrollyNameArray() {
			let rtn = this.scrolly ? (this.$i18n ? this.splitSentence(this.scrolly.name[this.$i18n.locale]) : '') : []
			return rtn
		},
		audioSpots() {
			return this.scrolly ? this.stages.map(el => el.audioSpot) : []
		},
		remarkablePoints() {
			let rtn = []
			if(this.scrolly.sections) {
				this.scrolly.sections.filter(el => el.remarkablePoints).forEach(el => {
					rtn = rtn.concat(el.remarkablePoints)
				})
			}
			return rtn
		},
		multiPlaceholderImage() {
			return require('@assets/icons/placeholder_multi.svg');
		}
	},
	watch: {
		currSection(n) {
			this.updateCurrentStage();
			if(this.scrollContainer !== null) {
				this.manageUrlGlobal();
			}
		},
		currentInDepth(n, o) {
			
			if(n && o) {
				if(n.visible && !o.visible) {
					// console.log('visible', cloneDeep(n))
					this.manageUrlGlobal();
				}

				if(!n.visible && o.visible) {
					// console.log('not visible anymore')
					this.manageUrlGlobal();
				}
			}
		},
		artifactModalVisible(n, o) {
			// if(this.isMobile)
			if(n && !o) {
				document.querySelector('body').style.overflow = 'hidden'
			}else{
				document.querySelector('body').style.overflow = 'unset'
			}
		},
		isMobile(n, o) {
			this.showResizeModal = true;
		},
		showPlayer() {
			this.managePlayerURL();
		},
		showScrolly(n, o) {
			if(n && !o) {
				// console.log('show scrolly')
				// this.addAnimationResizeListener();
			}
		}
	},
	methods: {
		...mapActions(['initStore']),
		async init() {
			let that = this;
			let url = this.$route.path.split('/');
			if (url[url.length - 1] == '') url.pop();
			const nameCode = url.pop();
			this.scrolly = cloneDeep(scrollies.scrollies.find(s => s.nameCode == nameCode));
			this.manageLoadingCurtain();
			
			await this.initStore();
			const scrolly = this.scrollys.find(scrolly => scrolly.attributes.link === nameCode);
			const getScrolly = this.getScrollytelling(scrolly.id);

			this.updateCurrentStage();
			await utils.isElLoaded('.scroll-container-window')
			this.initSections()

			const apiData = await getScrolly;
			this.getAllScrollyMedia(apiData);
			this.getAllScrollyArtifacts(apiData);
			// console.log(cloneDeep(this.artifacts))

			if(this.imagesCallback) await this.imagesCallback()
			if(!this.isMobile) this.manageLittleSpots();

			this.addSpotsListeners();
			this.manageArtifactModalAnimation();
			this.addResizeListener();
			if(!this.isMobile) {
				await nextTick();
				this.mountSectionsAnimations()
			} else {
				await utils.isElLoaded('.scroll-container section')
				this.mountMobileAnimations(this.mobileCbs)
				this.fixCuriositiesStyle();
				this.mountSectionsObservers();
				this.manageMobileRemarkablePoint();
			}
			await utils.isElLoaded('.scrolly-intro-1')

			if(!this.isMobile) this.introAnimation();

			this.manageInDepthInitialize();

			if(!this.isMobile) {
				await utils.allImagesLoaded()
				await this.manageUrlOnMounted()
				this.showScrolly = true;
			} else {
				await this.manageUrlOnMountedMobile()
			}
			this.initEmitterListeners();
			await utils.allImagesLoaded()
			this.fixTrailerLoop();
			await nextTick()
			this.showScrolly = true;
			await nextTick();
			this.mountScrollyVideosSubs()
		},
		initEmitterListeners() {
			this.emitter.on('open-artifact-modal', (artifact) => {
				// console.log('open artifact listener emitter', sectionId, artifactId)
				this.openArtifactModal(artifact);
			})

			this.emitter.on('show-in-depth', sectionId => {
				this.showInDepth(sectionId);
			})

			this.emitter.on('close-rm', obj => {
				this.closeMobileRemarkablePoint(obj);
			})

			this.emitter.on('select-rm', obj => {
				this.selectMobileRemarkablePoint(obj);
			})
		},
		async imagesLoadingListener() {
			// for(var image of Array.from(document.images)) {
			// 	console.log('image')
			// 	await image.decode()
			// 	console.log('image loaded', image.getAttribute('src'))
			// }
			let res = await utils.allImagesLoaded()
			this.showScrolly = true;
		},
		async getScrollytelling(id) {
			// console.log('id', id)

			let res = await API.getScrollytelling({
				id: id,
				fields: ['titolo', 'sottotitolo', 'locale'],
				populate: ['reperto.reperto.anteprima', 'reperto.reperto.media', 'reperto.reperto.localizations', 'media.asset'],
				locale: 'it',
			})
			res = await res.json();
			return res.data.attributes;
		},
		manageLoadingCurtain() {
			document.querySelector('.scrolly-loading-curtain').addEventListener('wheel', e => {
				e.stopPropagation()
			}, {passive: false})
		},
		async loadCurrentStage() {
			this.init()
			if(!this.isMobile) {
				var res = await utils.isElLoaded('.scrolly-stage-spot')
				// this.init();
				this.$watch('currSection', n => {
					this.manageProgressStage();
				})
			}else {
				// this.init();
				this.$watch('currSection', n => {
					this.manageProgressStage();
				})
			}
			this.manageProgressStage()
		},
		updateCurrentStage() {
			Array.from(document.querySelectorAll('.scrolly-stage-spot-cont')).forEach((sp, i) => {
				if(sp.getAttribute('data-stage-id').toString() == (this.currStage ? this.currStage : '0')) {
					sp.querySelector('.scrolly-stage-spot').innerHTML = `<div class="scrolly-current-spot"></div>`
				}else {
					sp.querySelector('.scrolly-stage-spot').innerHTML = ''
				}
			})
		},
		manageProgressStage() {
			window.requestAnimationFrame(() => {
				let amount = 0;
				let widthBar = document.querySelector('.scroll-progress-cont').getBoundingClientRect().width
				amount = utils.map(this.currStageSectionIndex+1, 0, this.currStageNumSections, 0, widthBar )
				document.querySelector('.scroll-stage-progress').style.transform = `translateX(calc(100% * -1 + ${amount}px))`;
			})
			// document.querySelector('.scroll-stage-progress').style.width = amount + 'px';
		},
		manageLittleSpots() {

			let linesObjects = []

			let manageLineObjects = () => {
				let spots = Array.from(document.querySelectorAll('.scrolly-stage-spot'))
				linesObjects = []
				spots.slice(0, spots.length-1).forEach((s, i) => {
					let spotBB = s.getBoundingClientRect()
					let nextSpotBB = spots[i+1].getBoundingClientRect()
					linesObjects.push({
						x1: spotBB.left + spotBB.width/2,
						y1: spotBB.top%window.innerWidth + spotBB.height/2,
						x2: nextSpotBB.left + nextSpotBB.width/2,
						y2: nextSpotBB.top%window.innerWidth + nextSpotBB.height/2,
					})
				})
			}

			manageLineObjects();

			let spotsBB = d3.select('.scrolly-stages-points').node().getBoundingClientRect()

			let numSpotsBTStages = 30;

			d3.select('.menu-cont')
				.append('svg')
				.attr('class', 'menu-nav-lines')
				.selectAll('menu-dotted-line')
				.data(linesObjects)
				.enter()
				.append('line')
				.attr('class', 'menu-dotted-line')
				.attr('x1', d => d.x1+'px')
				.attr('y1', d => d.y1+'px')
				.attr('x2', d => d.x2+'px')
				.attr('y2', d => d.y2+'px')
				.attr('stroke', 'white')
				.attr('stroke-width', '3.5')
				.attr('stroke-linecap', 'round')
				.attr('stroke-dasharray', d => '0.5 10px')

			let d3UpdateLines = () => {
				d3.selectAll('.menu-cont .menu-dotted-line')
					.data(linesObjects)
					.attr('x1', d => d.x1+'px')
					.attr('y1', d => d.y1+'px')
					.attr('x2', d => d.x2+'px')
					.attr('y2', d => d.y2+'px')
					.attr('stroke-dasharray', d => '0.5 10px')
			}

				window.addEventListener('resize', () => {
					manageLineObjects();
					d3UpdateLines();
				})
		},
		seekTimelinesForSection(destinationSection) {
			const destinationIndex = this.sections.indexOf(destinationSection);

			for (let i = this.sections.length - 2; i >= 0; i--) {
				const sect = this.sections[i];
				if (sect.id == 's1') continue;
				if (!this.scrollyTimelines[sect.id]) continue;
				
				if (i < destinationIndex) {
					// section before target, jump to end of animations
					this.scrollyTimelines[sect.id].forEach(t => t.pause(t.duration()));
					if (sect.fastforwardCb) sect.fastforwardCb();
				} else {
					// section after target, jump to start of animations
					this.scrollyTimelines[sect.id].slice().reverse().forEach(t => t.pause(0));
					if (sect.rewindCb) sect.rewindCb();
				}
			}
			
			if(destinationSection.id == 's1') {
				this.scrollyTimelines['s1'].slice().reverse().forEach(t => t.pause(0))
				if (destinationSection.rewindCb) destinationSection.rewindCb();
			}else {
				this.scrollyTimelines['s1']?.forEach(t => t.pause(t.duration()))
				if (destinationSection.fastforwardCb) destinationSection.fastforwardCb();
			}
			
			this.resetInhibitScroll();
			
			for (let i = 0; i < this.sections.length; i++) {
				if(i < destinationIndex) {
					this.sections[i].stepIndex = this.sections[i].numSteps-1;	
					// this.scrollyTimelines['s1'].forEach(t => t.pause(t.duration()))
				} else {
					this.sections[i].stepIndex = 0;
					// this.scrollyTimelines['s1'].reverse().forEach(t => t.pause(0))
				}
			}

			// console.log(cloneDeep(this.sections))
			// Object.keys(this.scrollyTimelines).forEach(k => {
			// 	this.scrollyTimelines[k].forEach((t, i) => {
			// 		console.log('timeline progress', k, i, t.progress())
			// 	})
			// })
		},
		addSpotsListeners() {
			Array.from(document.querySelectorAll('.scrolly-stage-spot-cont')).forEach((ssp, i) => {
				ssp.onclick = () => {
					let sectionDestination = this.sections
						.filter(s => s.stage)
						.find(s => s.stage.id == ssp.getAttribute('data-stage-id'));
					
					// in this part there will be the reset sections logic
					this.changeSection(this.sections.indexOf(sectionDestination), () => this.seekTimelinesForSection(sectionDestination));
				}

				ssp.onmouseenter = () => {
					let label = document.querySelector('.stage-label')
					let selectedId = ssp.getAttribute('data-stage-id')

					let stageName = this.stages.find(el => el.id == selectedId).name[this.$i18n.locale]

					let stageNameHTML = '';

					if(selectedId == this.stages[0].id) {
						stageNameHTML = `
						<p class="stage-label-name capitalize-first">
							${this.$t('generic_introduzione')}
						</p>`
					}else if(selectedId == this.stages[this.stages.length-1].id) {
						stageNameHTML = `
						<p class="stage-label-name capitalize-first">
							${this.$t('generic_riferimenti')}
						</p>`
					}else {
						stageNameHTML = `							
						<p class="stage-label-name capitalize-first">
							${stageName}
						</p>`
					}

					const rect = ssp.getBoundingClientRect();
					label.style = `top: ${rect.bottom - rect.height/2}px; left: calc(${rect.left}px + var(--menu-size)*1.25);transform: translateY(-50%);`

					let stageNumber = (selectedId == this.stages[0].id || selectedId == this.stages[this.stages.length-1].id) ? '' :
					`	<p class="stage-label-text">
							${this.$t('scrolly_tappa').toUpperCase()} ${this.stages.findIndex(el => el.id == selectedId)}
						</p>` 

					label.innerHTML = `
						<div class="stack-vertical stage-label-cont">
							${stageNumber}
							${stageNameHTML}
						</div>`
					label.classList.add('visible')
				}

				ssp.onmouseleave = () => {
					let label = document.querySelector('.stage-label')
					label.classList.remove('visible')
				}
			})
		},
		showInDepth(id, inDepth) {
			console.log('show inDepthId', id, inDepth)
			this.currentInDepth = inDepth ? cloneDeep(inDepth) : cloneDeep(this.getSectionById(id).inDepthItem)
			if (!this.currentInDepth) return;
			this.currentInDepth.idSection = id;
			this.currentInDepth.visible = true;
			this.setInhibitScroll()
		},
		closeInDepth(id) {
			this.currentInDepth = cloneDeep(this.currentInDepth)
			this.currentInDepth.visible = false;
			this.resetInhibitScroll();
		},
		getSources(media, prefix) {
			const sources = [];
			if (media[prefix+'-webm']) sources.push({ url: media[prefix+'-webm'].url, type: 'video/webm' });
			if (media[prefix+'-mov']) sources.push({ url: media[prefix+'-mov'].url, type: 'video/quicktime;codecs=hvc1' });
			if (media[prefix+'-mp4']) sources.push({ url: media[prefix+'-mp4'].url });
			if (media[prefix]) sources.push({ url: media[prefix].url });
			return sources;
		},
		showVideo(sources, srts) {
			// console.log('srt', cloneDeep(srts))
			this.currentVideo = { sources, visible: true, srts };
			this.setInhibitScroll()
		},
		closeVideo() {
			this.currentVideo.visible = false;
			if(!this.isMobile) this.resetInhibitScroll()
		},
		getAllScrollyMedia(apiData) {
			this.media = Object.fromEntries(apiData.media.map(o => {
				const attr = o.asset?.data?.attributes;
				if (!attr) return [];
				attr.url = attr.url && utils.parseMediaUrl(attr.url);
				attr.previewUrl = attr.previewUrl && utils.parseMediaUrl(attr.previewUrl);
				// console.log(o.subs)
				if(o.subs) attr.subs = o.subs

				return [o.key, attr]
			}));
		},
		getAllScrollyArtifacts(apiData) {
			this.artifacts = Object.fromEntries(apiData.reperto.map(o => {
				if(o.reperto.data) {
					const attr = o.reperto.data.attributes;
					attr.anteprima = utils.parseMediaUrl(
						attr.anteprima.data
							? attr.anteprima.data.attributes.formats.large.url
							: (attr.media.data && attr.media.data[0].attributes.formats ? attr.media.data[0].attributes.formats.large.url : '')
					);

					// overwrite with localized data
					const localizedObj = attr.localizations.data.find(l => l.attributes.locale == this.$i18n.locale);
					if (localizedObj && localizedObj.attributes.publishedAt) {
						o.reperto.data.id = localizedObj.id;
						Object.assign(attr, localizedObj.attributes);
					}

					return [o.key, o.reperto.data];
				}else {
					return []
				}
			}));
		},
		manageArtifactModalAnimation() {
			let el = document.querySelector('.sc-artifact-modal')
			// el.style.zIndex = -1
			// el.ontransitionend = e => {
			// 	if(!this.artifactModalVisible && e.propertyName == 'opacity') {
			// 		document.querySelector('.sc-artifact-modal-cont').style.zIndex = -1;
			// 	}
			// }
			document.querySelector('.sc-artifact-modal').onclick = e => e.stopPropagation()
			document.querySelector('.sc-artifact-modal-cont').style.zIndex = -1;
		},
		async openArtifactModal(artifact) {

			if(typeof artifact == 'object') this.currArtifact = artifact
			else if(typeof artifact == 'string') this.currArtifact = this.artifacts[artifact]

			// console.log('artifact', artifact, cloneDeep(this.currArtifact))

			if(!artifact) return
			// console.log('currArtifact', cloneDeep(this.currArtifact))
			await nextTick()

			document.querySelector('.sc-artifact-modal-cont').style.zIndex = 3;
			document.querySelector('.sc-artifact-modal-cont').style.pointerEvents = 'all';
			document.querySelector('.sc-artifact-modal').style.pointerEvents = 'all';
			let setImageType = imgElQuery => {
				let elBB = document.querySelector(imgElQuery).getBoundingClientRect();
				this.modalArtifactMode = elBB.width > elBB.height ? 'landscape' : 'portrait'
			}
			if(this.currArtifact.attributes.anteprima.length) {
				let imgElQuery = `.sc-artifact-modal-img img`
				utils.isImageLoaded(document.querySelector(imgElQuery))
					.then(() => {
						// setImageType(imgElQuery)
						this.artifactModalVisible = true
					});
			}else {
				this.artifactModalVisible = true
			}
			// }
		},
		goToBlankArtifact(id) {
			const href = this.$router.resolve({ name: 'artifact', params: { id } }).href;
			// console.log(this.$router.resolve({ name: 'artifact', params: { id } }));
			window.open(href, '_blank');
		},
		closeArtifactModal() {
			this.artifactModalVisible = false;
			document.querySelector('.sc-artifact-modal-cont').style.pointerEvents = 'none';
			document.querySelector('.sc-artifact-modal').style.pointerEvents = 'none';
		},
		// onCompleteAppearContents(id) {
		// 	document.querySelector(`.scrolly-artifact-container[data-artifact-id="${id}"] .artifact-comic`).style.opacity = 1
		// },
		setTitleHover(bool) {
			this.titleHover = bool;
		},
		testSomething() {
			setTimeout(() => {
				this.sections[0].steps[0].inDepthItem.visible = true;
			}, 1000)
		},
		addResizeListener() {
			window.addEventListener('resize', this.manageProgressStage)
		},
		isStageInactive(stageId) {
			return this.currentBibliographyStage ? this.currentBibliographyStage.id !== stageId : false
		},
		goToArtifactSection(artifactId) {
			// this.goToSection(parseInt(this.scrolly.sections.filter(s => s.artifact).find(s => s.artifact.id == artifactId).id.replace('s', '')))
			const section = this.scrolly.sections.filter(s => s.artifact).find(s => s.artifact.id == artifactId);
			this.goToSection(this.scrolly.sections.indexOf(section) + 1, () => this.seekTimelinesForSection(section.id));
		},
		managePlayerURL() {
			let temp = utils.URLToParams()
			if(temp) {
				delete temp.player;
			}

			// let	finalString = utils.paramsToURL({...temp, player: this.showPlayer});
			// history.replaceState(history.state, '', finalString);
			this.$router.replace({ query: { ...temp, player: this.showPlayer } });
		},
		manageStageURL() {
			let temp = utils.URLToParams()
			if(temp) {
				delete temp.stageId;
			}

			let	finalString = utils.paramsToURL({...temp, stageId: this.currStage});
			history.replaceState(history.state, '', finalString);
			// history.replaceState(history.state, '', finalString);
			this.$router.replace({ query: finalString });
		},
		manageUrlGlobal() {
			let temp = utils.URLToParams()
			let finalObj = {}
			if(temp) {
				delete temp.sectionId;
				delete temp.inDepth;
			}

			finalObj = cloneDeep(temp)

			if(this.currSection) {
				finalObj = {...finalObj, sectionId: this.currSection.id}
			}

			if(this.currentInDepth) {
				if(this.currentInDepth.visible) {
					finalObj = {...finalObj, inDepthId: this.currentInDepth.id}
				}else {
					delete finalObj.inDepthId;
				}
			}

			this.$router.replace({ query: finalObj })
		},
		managePlayerOnMounted() {
			let params = utils.URLToParams()
			if(params && params.player) {
				this.showPlayer = params.player == 'true' ? true : false;
			}
		},
		manageStageOnMounted() {
			let params = utils.URLToParams()
			if(!params) return

			if(params.stageId) {
				let index = this.sections.findIndex(el => el.stage.id == params.stageId) + 1
				if(index > 1) this.goToSection(index)
			}
		},
		async manageUrlOnMounted() {
			return new Promise(resolve => {
				let params = utils.URLToParams()
				if(!params) resolve()

				if(params.sectionId) {

					let cb = () => {
						this.seekTimelinesForSection(this.sections.find(s => s.id == params.sectionId))
						resolve()
					}

					if(params.inDepthId) {
						let currSection = this.sections.find(el => el.id == params.sectionId)
						cb = () => {
							this.seekTimelinesForSection(this.sections.find(s => s.id == params.sectionId))
							this.showInDepth(currSection.id);
							resolve()
						}
					}


					let index = this.sections.findIndex(el => el.id == params.sectionId) + 1
					if(index > 1) this.goToSection(index, cb)
					else resolve()
				}else {
					resolve()
				}
			})
		},
		async manageUrlOnMountedMobile() {
			let params = utils.URLToParams() ?? {};

			if(params.sectionId) {
				const el = document.getElementById(params.sectionId);
				if (el) el.scrollIntoView();

				/*
				if(params.inDepthId) {
					let currSection = this.sections.find(sect => sect.inDepthItem?.id == params.inDepthId)
					if (currSection) {
						nextTick(() => this.showInDepth(null, currSection.inDepthItem));
					}
				}
				*/
			} else {
				window.scrollTo(0,0);
			}
		},
		manageSectionOnMounted() {
			let params = utils.URLToParams()
			if(!params) return

			if(params.sectionId) {
				let index = this.sections.findIndex(el => el.id == params.sectionId) + 1
				if(index > 1) this.goToSection(index)
			}
		},
		splitSentence(sentence) {
		  const words = sentence.split(' '); // Split sentence into words
		  
		  // Loop through words and combine short words with next word
		  for (let i = 0; i < words.length - 1; i++) {
		    if (words[i].length < 3) {
		      words[i] = words[i] + ' ' + words[i + 1];
		      words.splice(i + 1, 1); // Remove the next word since it's been combined
		      i--; // Decrement i to re-evaluate the current word
		    }
		  }
		  
		  return words;
		},
		imageIntroFromIndex(index) {
			return this.scrolly.introImages[index];
		},
		manageInDepthInitialize() {
			let item = cloneDeep(this.sections.map(el => el.inDepthItem).filter(el => el)[0])
			this.currentInDepth = cloneDeep(this.sections.map(el => el.inDepthItem).filter(el => el)[0])
			utils.isElLoaded('.in-depth-item-container')
				.then(() => {
					document.querySelector('.in-depth-item-container').style.zIndex = -1;
				})
		},
		manageMobileRemarkablePoint() {
			if(!this.sections.find(s => s.remarkablePoints)) return

			let firstRemarkable = cloneDeep(this.sections.find(s => s.remarkablePoints).remarkablePoints[0]);
			this.currMobileRemarkablePt = firstRemarkable;
		},
		selectMobileRemarkablePoint(obj) {
			this.currMobileRemarkablePt = {
				...obj,
				visible: true
			}
			// console.log('id', cloneDeep(this.currMobileRemarkablePt))
		},
		closeMobileRemarkablePoint() {
			this.currMobileRemarkablePt = {
				...this.currMobileRemarkablePt,
				visible: false
			}
		},
		goBack() {
			this.$router.replace({ name: 'home' });
		},
		fixCuriositiesStyle() {
			// for(let item of Array.from(document.querySelectorAll('.scrolly-content-curiosity'))) {
			// 	await
			// }
			// console.log('here', document.querySelectorAll('.scrolly-content-curiosity'))
			Array.from(document.querySelectorAll('.scrolly-content-curiosity')).forEach(c => {
				let bb = c.getBoundingClientRect()
				let scale = window.innerWidth / bb.width;
				// console.log('scale', scale)
				let leftAmount = (bb.width - window.innerWidth)/2;
				c.setAttribute('data-new-scale', scale)
				c.setAttribute('data-left', leftAmount)
				// c.style.transform = `rotate(-5deg) translate(calc(50vw - 50% - ${leftAmount}px)) scale(${scale})`
			})
		},
		addAnimationResizeListener() {
			window.addEventListener('resize', () => {
				Object.keys(this.scrollyTimelines).forEach(k => {
					this.scrollyTimelines[k].forEach((t, i) => {
						// console.log("i'm the timeline", i, t)
						t.seek(t.time())
					})
				})
			})
		},
		fixTrailerLoop() {
		  Array.from(document.querySelectorAll('video')).forEach(video => {
		  	if(video.querySelector('source')) {
		  		if(video.querySelector('source').getAttribute('src').indexOf('#t=0,5') > -1) {
			  			// console.log('url', video.querySelector('source').getAttribute('src'))
			  			video.ontimeupdate = () => {
			  				if(video.currentTime >= 5) {
									video.pause();
									video.currentTime = 0;
									video.play();
			  				}
			  			}
		  		}
		  	}
		  })
		},
		mountScrollyVideosSubs() {
			let videosIds = Array.from(document.querySelectorAll('.scroll-page-container .section-cont')).filter(el => el.querySelector('video')).map(el => el.getAttribute('id'))
			videosIds.forEach(id => {
				let videoEl = document.querySelector(this.isMobile ? `#${id} video` : `#${id} video.check-subs`)
				let videoKeys = Object.keys(this.media).filter(el => el.startsWith(`${id}-`))
				if(videoKeys.length && videoEl) {
					let videosPerSection = Array.from(document.querySelectorAll(this.isMobile ? `#${id} video` : `#${id} video.check-subs`))
					if(videosPerSection.length > 1) { // more that one video (for now, only in dialetti)
						videosPerSection.forEach(ve => {
							let videoId = ve.getAttribute('id').replace('-video', '');
							if(this.media[videoId].subs.length) {
								this.loadVideoTracks(ve, this.media[videoId].subs)
							}
						})
					}else {
						if(this.media[videoKeys[0]].subs.length) {
							this.loadVideoTracks(videoEl, this.media[videoKeys[0]].subs)
						}
					}
				}
				// console.log('videoKeys', videoKeys)
			})
		},
		loadVideoTracks(video, subs) {
			Array.from(video.querySelectorAll('track')).forEach(t => t.remove())

			// console.log('ADDING SUBS', video, subs)

			subs.forEach(sub => {
				var track = document.createElement("track");
				track.mode = "showing";
				track.label = sub.lang == 'en' ? "English" : "Italian";
				track.setAttribute('data-lang', sub.lang)
				track.kind = "subtitles";
				track.srclang = sub.lang;
				// track.src = this.subsVideo;
				track.default = true;
				video.appendChild(track);

				utils.loadTrackWithAjax(track, sub.url)
			})

			Array.from(video.querySelectorAll('track')).forEach(t => t.removeAttribute('default'))
			Array.from(video.querySelectorAll('track')).forEach(t => {
				if(t.getAttribute('data-lang') == this.$i18n.locale) {
					t.default = true;
				}
			})
		},
	},
	async mounted() {
		if(this.priorityMounted) {
			this.priorityMounted();
		}else {
			this.converter = new Converter();
			this.loadCurrentStage().catch(err => console.error(err));
			this.managePlayerOnMounted();
			this.manageMobileRemarkablePoint();
			document.addEventListener('wheel', function touchHandler(e) {
				if (e.ctrlKey) {
					e.preventDefault();
				}
			},{ passive: false })	
		}
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.manageProgressStage)
		document.querySelector('.sc-artifact-modal-cont').addEventListener('wheel', utils.stopPropagation)
		document.removeEventListener('wheel', function touchHandler(e) {
			if (e.ctrlKey) {
				e.preventDefault();
			}
		},{ passive: false })
	}
}	
